import { Dropdown, Label } from '@components';

import QuickCollectFields from './QuickCollectFields';
import { QuickCollectGroupFormData } from './types';
import useGroupOptions from './useGroupOptions';

interface QuickCollectGroupStepProps {
  leadName: string;
  formData: QuickCollectGroupFormData;
  nameApiError?: string;
  onChange: (data: Partial<QuickCollectGroupFormData>) => void;
}

const QuickCollectGroupStep = ({
  leadName,
  formData,
  nameApiError,
  onChange
}: QuickCollectGroupStepProps) => {
  const groupOptions = useGroupOptions(formData.branchId);

  const handleGroupSelect = (value: string) => {
    const group = groupOptions.find((g) => g.value === value);
    onChange({ groupId: value, groupName: group?.label || '' });
  };

  return (
    <QuickCollectFields
      leadName={leadName}
      name={formData.name}
      branchId={formData.branchId}
      amount={formData.amount}
      notes={formData.notes}
      nameApiError={nameApiError}
      onNameChange={(val) => onChange({ name: val })}
      onBranchSelect={(value, label) =>
        onChange({
          branchId: value,
          branchName: label,
          groupId: '',
          groupName: ''
        })
      }
      onAmountChange={(val) => onChange({ amount: val })}
      onNotesChange={(val) => onChange({ notes: val })}
      afterBranch={
        <div>
          <Label
            label="Group"
            isRequired
            className="!mb-2 !text-sm !font-semibold"
          />
          <Dropdown
            currentFilter={formData.groupId}
            filterOptions={groupOptions}
            onSelectFilter={handleGroupSelect}
            className="h-12 w-full !rounded-lg"
            optionsStyle="!w-full max-h-56 overflow-y-auto"
            labelStyle="truncate"
            optionItemClassName="break-all"
            placeholder="Select Group"
            searchBarPlaceholder="Search group"
            disabled={!formData.branchId}
            usePortal
          />
        </div>
      }
    />
  );
};

export default QuickCollectGroupStep;
